export const s3UploadOptions = (file, signedRequestObj) => {
  const options = {
    url: signedRequestObj.url,
    signature: signedRequestObj.signature,
    policy: signedRequestObj.policy,
    accessKey: signedRequestObj.accessKey,
    key: signedRequestObj.key,
    filename: signedRequestObj.filename,
    contentType: signedRequestObj.contentType,
    formData: new FormData(),
    full_url: signedRequestObj.url + signedRequestObj.key,
    file,
    provider: 's3',
  };

  options.formData.append('key', options.key);
  options.formData.append('acl', 'public-read');
  options.formData.append('Content-Type', options.contentType);
  options.formData.append('AWSAccessKeyId', options.accessKey);
  options.formData.append('policy', options.policy);
  options.formData.append('signature', options.signature);
  options.formData.append('Content-Length', file.size || 50000000);
  options.formData.append('file', options.file);

  return options;
};

export const gcsUploadOptions = (file, signedRequestObj) => {
  const options = {
    url: signedRequestObj.url,
    contentType: signedRequestObj.contentType,
    expires: signedRequestObj.signature_params.expires,
    googleAccessId: signedRequestObj.signature_params.GoogleAccessId,
    signature: signedRequestObj.signature,
    filename: signedRequestObj.filename,
    policy: signedRequestObj.policy,
    bucket: signedRequestObj.bucket,
    path: signedRequestObj.path,
    full_url: signedRequestObj.full_url,
    formData: new FormData(),
    file,
    provider: 'gcs',
  };

  options.formData.append('signature', options.signature);
  options.formData.append('key', options.path);
  options.formData.append('policy', options.policy);
  options.formData.append('Content-Type', options.contentType);
  options.formData.append('Content-Length', file.size || 50000000);
  options.formData.append('GoogleAccessId', options.googleAccessId);
  options.formData.append('bucket', options.bucket);
  options.formData.append('acl', 'public-read');
  options.formData.append('file', options.file);

  return options;
};
